import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { axiosapi, axiosPrivate } from "../api/axios";
import { useSelector, useDispatch } from 'react-redux';
import { saveAccessToken, getAccessToken, refreshTokenExpired } from '../redux/ActionCreators';



const useAxiosPrivate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accessToken = useSelector((state) => state.auth.token);
    useEffect(() => {

        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${accessToken}`;

                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;

                if (error?.response?.status === 403 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    try {
                        const response = await axiosapi.get('/refresh', { withCredentials: true });
                        dispatch(getAccessToken(response.data))


                        prevRequest.headers.Authorization = `Bearer ${response.data.accessToken}`;


                        return axiosPrivate(prevRequest);
                    }
                    catch {
                        navigate('/login');
                    }

                }
                return Promise.reject(error);
            }
        );
        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [])

    return axiosPrivate;
}

export default useAxiosPrivate;